import { useContext } from 'react'
import {
  EditorContentContext,
  EditorContentDispatchContext,
  NeedsUploadContext,
  NeedsUploadDispatchContext,
} from './context'

export function useEditorContent() {
  const context = useContext(EditorContentContext)
  if (context === undefined) {
    throw new Error(
      'useEditorContent must be used within a EditorContentProvider'
    )
  }
  return context
}

export function useEditorContentDispatch() {
  const context = useContext(EditorContentDispatchContext)
  if (context === undefined) {
    throw new Error(
      'useEditorContentDispatch must be used within a EditorContentProvider'
    )
  }
  return context
}

export function useNeedsUpload() {
  return useContext(NeedsUploadContext)
}

export function useNeedsUploadDispatch() {
  const context = useContext(NeedsUploadDispatchContext)
  if (context === undefined) {
    throw new Error(
      'useNeedsUploadDispatch must be used within a EditorContentProvider'
    )
  }
  return context
}
